import { useState } from 'react'
import { motion as Motion, AnimatePresence, useReducedMotion } from 'motion/react'

export function Modal({ isOpen, onClose, title, children, sidebarCollapsed = false, isDarkMode = false, managed = false }) {
  const [pos, setPos] = useState({ x: 0, y: 0 })
  const [dragging, setDragging] = useState(false)
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 })
  const shouldReduceMotion = useReducedMotion()

  const sidebarWidth = sidebarCollapsed ? 64 : 224

  const handleMouseDown = (e) => {
    if (e.target.closest('input, textarea, select, button:not(.drag-handle)')) return
    setDragging(true)
    setDragStart({ x: e.clientX - pos.x, y: e.clientY - pos.y })
  }

  const handleMouseMove = (e) => {
    if (!dragging) return
    setPos({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y })
  }

  const handleMouseUp = () => {
    setDragging(false)
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 p-8 pointer-events-none"
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <Motion.div
            className={`absolute rounded-xl shadow-2xl border h-[90vh] flex flex-col pointer-events-auto w-full transition-colors duration-300 ${isDarkMode ? 'border-slate-700' : 'bg-white border-gray-200'}`}
            initial={shouldReduceMotion ? false : { opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: shouldReduceMotion ? 0 : 0.2, ease: [0.16, 1, 0.3, 1] }}
            style={{
              left: `${sidebarWidth + 32 + pos.x}px`,
              right: `${Math.max(16 - pos.x, 16)}px`,
              maxWidth: '896px',
              top: `${32 + pos.y}px`,
              cursor: dragging ? 'grabbing' : 'grab',
              backgroundColor: isDarkMode ? '#1e293b' : '#ffffff',
              borderColor: isDarkMode ? '#475569' : undefined
            }}
          >
            <div
              className="flex justify-between items-center px-6 py-4 border-b flex-shrink-0 cursor-grab active:cursor-grabbing select-none transition-colors duration-300"
              style={{
                borderColor: isDarkMode ? '#475569' : '#cccccc',
                backgroundColor: isDarkMode ? '#1e293b' : undefined
              }}
              onMouseDown={handleMouseDown}
            >
              <h2 className="text-xl font-bold" style={{ color: isDarkMode ? '#e2e8f0' : '#333333' }}>{title}</h2>
              <button
                onClick={onClose}
                className="text-2xl leading-none transition-colors"
                style={{ color: isDarkMode ? '#94a3b8' : '#333333' }}
                onMouseEnter={(e) => e.target.style.color = '#F5A623'}
                onMouseLeave={(e) => e.target.style.color = isDarkMode ? '#94a3b8' : '#333333'}
              >
                ×
              </button>
            </div>
            <div
              className={`flex-1 ${managed ? 'overflow-hidden flex flex-col px-6 pt-4' : 'px-6 py-4 overflow-y-auto'} ${isDarkMode ? 'dark-mode-form' : ''}`}
              style={{ backgroundColor: isDarkMode ? '#1e293b' : '#ffffff' }}
            >
              {children}
            </div>
          </Motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}
